import { useQuery } from "@tanstack/react-query"

import { FindProdSiteFieldDefsByOrgIdResponse } from "@tfg/types/schemas/modules/traceability/dtos/find-prod-site-field-defs-by-org-id.dto"

import { httpClient } from "~/backend/axios"
import { i18n } from "~/i18n"

export const useListProdSiteFieldDefsQuery = (orgId?: string) =>
  useQuery({
    queryKey: ["prodSiteFieldDefs", orgId],

    queryFn: async () => {
      if (!orgId) return []

      const lang = i18n.language.toUpperCase()

      const res = await httpClient.get<FindProdSiteFieldDefsByOrgIdResponse>(
        `admin/traceability/find-prod-site-field-defs/${orgId}`,
        {
          headers: {
            "accept-language": lang,
          },
        }
      )
      return res.data
    },
  })
